<template>
  <vs-popup class="popup-risk-assessment-db"
            title="위험성평가 D/B"
            :active.sync="showPopup">
    <!-- vs-popup 은 닫혀있어도 슬롯 내용을 렌더링하므로, v-if 로 감싸지 않으면
         k-pagination 이 mount 되면서 change 이벤트를 발생시켜 목록 API 가 미리 호출된다. -->
    <div v-if="showPopup">
      <!-- search -->
      <div class="keyword-search grid gap-2 xl:flex xl:items-center">
        <div class="flex justify-center items-center">
          <div class="search-label">사업장</div>
          <div class="search-input-container">
            <vs-select class="w-full" v-model="selectedFieldId">
              <vs-select-item :value="0" text="전체" />
              <vs-select-item v-for="item in fields" :key="item.id" :value="item.id" :text="item.field_name" />
            </vs-select>
          </div>
        </div>
        <div class="ml-0 xl:ml-auto flex justify-center items-center">
          <div class="search-label">키워드</div>
          <div class="search-input-container">
            <ml-input class="search-input" v-model="키워드" @keyup.enter="onApplyKeyword" placeholder="검색어를 입력하세요"/>
            <vs-button size="small" type="flat" icon="close" class="clear-button" @click="onClearKeyword" v-if="키워드" />
          </div>
        </div>
        <vs-button size="medium" color="primary" class="search-button" @click="onApplyKeyword" >검색</vs-button>
      </div>

      <!-- table -->
      <div class="overflow-x-auto">
        <table>
          <colgroup>
            <col width="40px"/>
            <col width="63px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="54px"/>
            <col width="54px"/>
            <col width="54px"/>
            <col width="170px"/>
          </colgroup>
          <thead>
          <tr>
            <th rowspan="2">
                <span class="flex justify-center">
                  <vs-checkbox :value="isAllCheck" @change="changeAllCheck" />
                </span>
            </th>
            <th rowspan="2">No.</th>
            <th rowspan="1">팀(업체)명</th>
            <th rowspan="1">공장명</th>
            <th rowspan="1">대분류</th>
            <th rowspan="1">중분류</th>
            <th rowspan="1">소분류</th>
            <th rowspan="2">위험구분</th>
            <th rowspan="2">원인</th>
            <th rowspan="2">위험요인</th>
            <th rowspan="2">현재관리상태</th>
            <th colspan="3">위험도</th>
            <th rowspan="2">감소대책</th>
          </tr>
          <tr>
            <th>
              <vs-select autocomplete class="header-select" size="small" v-model="nav.팀업체명">
                <vs-select-item v-for="item in 팀업체명" :key="item" :value="item" :text="item" />
              </vs-select>
            </th>
            <th>
              <vs-select autocomplete class="header-select" size="small" v-model="nav.공장명" :disabled="(!nav.팀업체명 || nav.팀업체명 === '전체')">
                <vs-select-item v-for="item in 공장명" :key="item" :value="item" :text="item" />
              </vs-select>
            </th>
            <th>
              <vs-select autocomplete class="header-select" size="small" v-model="nav.대분류">
                <vs-select-item v-for="item in 대분류" :key="item" :value="item" :text="item" />
              </vs-select>
            </th>
            <th>
              <vs-select autocomplete class="header-select" size="small" v-model="nav.중분류" :disabled="(!nav.대분류 || nav.대분류 === '전체')">
                <vs-select-item v-for="item in 중분류" :key="item" :value="item" :text="item" />
              </vs-select>
            </th>
            <th>
              <vs-select autocomplete class="header-select" size="small" v-model="nav.소분류" :disabled="(!nav.대분류 || nav.대분류 === '전체') || (!nav.중분류 || nav.중분류 === '전체')">
                <vs-select-item v-for="item in 소분류" :key="item" :value="item" :text="item" />
              </vs-select>
            </th>
            <th>빈도</th>
            <th>강도</th>
            <th>종합</th>
          </tr>
          </thead>
          <tbody>
          <!-- 조회에 시간이 오래 걸릴 수 있으므로, 목록이 비어있는 이유를 안내한다 -->
          <tr v-if="isLoading">
            <td colspan="15" class="message-row">
              <span class="flex justify-center items-center gap-2">
                <span class="loading-spinner"></span>
                위험성평가 D/B 목록을 불러오는 중입니다. 잠시만 기다려 주세요.
              </span>
            </td>
          </tr>
          <tr v-else-if="list.length === 0">
            <td colspan="15" class="message-row">조회된 위험성평가 D/B 가 없습니다.</td>
          </tr>
          <tr v-for="(item, rowIndex) in list" :key="item.id" @click.stop.prevent="onRowToggle(item)" class="table-row" :class="{active: checked.find(checkedItem => checkedItem.id === item.id)}">
            <td>
              <span class="flex justify-center relative">
                <vs-checkbox :value="checked.find(checkedItem => checkedItem.id === item.id)" disabled />
              </span>
            </td>
            <td>{{ currentPage * perPage - perPage + rowIndex + 1 }}</td>
            <!-- 팀(업체)명은 813(팀명)/814(업체명) 모두 위험성평가정보.팀 으로 정규화되어 저장된다 -->
            <td>{{ item.info.위험성평가정보['팀'] || "-" }}</td>
            <td>{{ item.info.공정분류['raw.공장명'] || "-" }}</td>
            <td>{{ item.info.공정분류['raw.대분류'] || "-" }}</td>
            <td>{{ item.info.공정분류['raw.중분류'] || "-" }}</td>
            <td>{{ item.info.공정분류['raw.소분류'] || "-" }}</td>
            <td>{{ item.item_data.분류 || item.item_data.작업단계 || "-" }}</td>
            <td>{{ item.item_data.원인 || "-" }}</td>
            <td>{{ item.item_data.위험요인 || "-" }}</td>
            <!-- DKRAS 표는 "현재조치관리상태", JSA 표는 "현재관리상태" 로 필드명이 다르다 (813/814 Write.vue 참고) -->
            <td>{{ item.item_data.현재조치관리상태 || item.item_data.현재관리상태 || "-" }}</td>
            <td>{{ item.item_data.발생빈도 || "-" }}</td>
            <td>{{ item.item_data.위험강도 || "-" }}</td>
            <td>{{ item.item_data.위험도 || "-" }}</td>
            <td>{{ item.item_data.감소대책 || "-" }}</td>
          </tr>
          </tbody>
        </table>
        <!-- 페이징 -->
        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <!-- v-model 대신 :value 를 사용한다. v-model 로 바인딩하면 페이지 이동 시 change 보다 input 이 먼저
                 전달되어 currentPage 가 미리 갱신되고, onChangePage 의 중복 호출 가드에 걸려 목록이 갱신되지 않는다. -->
            <k-pagination :total="lastPage ? lastPage : 1" :value="currentPage" @change="onChangePage"></k-pagination>
          </div>
        </div>
      </div>

      <!-- buttons -->
      <div class="pt-5 flex justify-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="onClose">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="onSelect">등록</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "PopupRiskAssessmentDB",
  components: {
    KPagination
  },
  props: {
    value: Boolean,
    maxItemCount: {
      type: Number,
      default: 0, // 0일 경우, 제한 없음
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    },
    isAllCheck () {
      let isAllCheck = false;
      for (const item of this.currentPageItems) {
        if (!this.checked.find(checkedItem => checkedItem.id === item.id)) {
          isAllCheck = false;
          break;
        }
        isAllCheck = true;
      }
      return isAllCheck;
    },


    // 현재 페이지에 표시할 목록들 (전체선택 체크박스 대상)
    // 검색조건과 페이징은 모두 서버에서 처리되어 list 로 내려오므로, 여기서 다시 거르거나 자르지 않는다.
    // (list 의 항목은 { info, item_data, ... } 구조라 예전처럼 item.대분류 로 거르면 항상 0건이 됐다)
    currentPageItems () {
      return this.list;
    },
  },
  watch: {
    showPopup (val) {
      if (val) {
        this.checked = [];
        this.currentPage = 1;
        this.loadOptions();
        this.loadList();
        this.loadFieldList(1);
      }
    },
    nav: {
      deep: true,
      handler () {
        if (!this.nav.팀업체명 || this.nav.팀업체명 === '전체') {
          this.nav.공장명 = "전체";
        }
        if (!this.nav.대분류 || this.nav.대분류 === '전체') {
          this.nav.중분류 = "전체";
          this.nav.소분류 = "전체";
        } else if (!this.nav.중분류 || this.nav.중분류 === '전체') {
          this.nav.소분류 = "전체";
        }

        this.currentPage = 1;
        this.loadOptions();
        this.loadList();
      }
    },
    selectedFieldId: {
      handler (value) {
        if (value && value > 0) {
          this.currentPage = 1;
          this.loadList();
          this.loadOptions();
        }
      }
    },
  },
  data () {
    return {
      팀업체명: [],
      공장명: [],
      대분류: [],
      중분류: [],
      소분류: [],
      키워드: "",
      nav: {
        팀업체명: "전체",
        공장명: "전체",
        대분류: "전체",
        중분류: "전체",
        소분류: "전체",
        키워드: "",
      },
      lastPage: 1,
      currentPage: 1,
      total: 0,
      perPage: 20,
      list: [],
      isLoading: false,
      checked: [],
      fields: [],
      selectedFieldId: 0,
    }
  },
  methods: {
    // TODO: 대분류/중분류/소분류는 813/814 문서 저장 시점에 736/895(공정분류표)에서 복사된 raw 스냅샷이라,
    // 736/895에서 이름이 바뀌면(개정) 여기 옵션과 검색 결과는 여전히 옛 이름 기준으로 남는다.
    // 813/814/815(List.js, Page.vue)는 raw.id로 736/895의 최신 데이터를 조회해서 이 문제를 해결했지만,
    // 여기서 실제 목록 조회에 쓰는 board/LOAD_RISK_ASSESSMENT(loadList 내부) 백엔드 API는
    // category1/2/3 파라미터가 텍스트 매칭만 지원하고 id 기반 매칭을 지원하지 않는다
    // (boardAction.js의 LOAD_RISK_ASSESSMENT 파라미터 목록에 id 계열 필드가 없음, 2026-08 확인).
    // 그래서 옵션만 최신 이름으로 바꾸면 "보이는 값과 실제 검색되는 값이 달라져서" 리네임된 항목은 검색 결과가 0건이 되는
    // 부작용이 생겨, 지금은 옵션도 raw 텍스트 그대로 쓰도록 원복해둔 상태.
    // 백엔드에서 LOAD_RISK_ASSESSMENT가 raw.id(또는 그에 준하는 식별자) 기반 매칭을 지원하게 되면,
    // 이 함수와 loadList()의 category1/2/3 전달부를 813/814/815와 동일한 방식(raw.id 매칭)으로 같이 바꿔야 한다.
    loadOptions() {
      const keywords = [
        (this.nav.팀업체명 && this.nav.팀업체명 !== '전체') ? this.nav.팀업체명 : "",
        (this.nav.공장명 && this.nav.공장명 !== '전체') ? this.nav.공장명 : "",
        (this.nav.대분류 && this.nav.대분류 !== '전체') ? this.nav.대분류 : "",
        (this.nav.중분류 && this.nav.중분류 !== '전체') ? this.nav.중분류 : "",
        (this.nav.소분류 && this.nav.소분류 !== '전체') ? this.nav.소분류 : "",
      ];


      HttpRequest.get("/api/v1/post/options", {
        params: {
          boardIds: [813, 814],
          options: [
            "body.위험성평가정보.팀",
            "body.공정분류.raw.공장명",
            "body.공정분류.raw.대분류",
            "body.공정분류.raw.중분류",
            "body.공정분류.raw.소분류",
          ],
          keywords,
          fieldId: this.selectedFieldId ? this.selectedFieldId : undefined,
        },
      })
        .then((response) => {
          if (response) {
            const keys = Object.keys(response);

            for (const key of keys) {
              switch (key) {
              case "body.위험성평가정보.팀":
                this.팀업체명 = [
                  '전체', ...response[key].sort((a, b) => {
                    if (a > b) return 1;
                    if (a < b) return -1;
                    return 0;
                  })
                ];
                break;
              case "body.공정분류.raw.공장명":
                this.공장명 = [
                  '전체', ...response[key].sort((a, b) => {
                    if (a > b) return 1;
                    if (a < b) return -1;
                    return 0;
                  })
                ];
                break;
              case "body.공정분류.raw.대분류":
                // 이름 오름차순
                this.대분류 = [
                  '전체', ...response[key].sort((a, b) => {
                    if (a > b) return 1;
                    if (a < b) return -1;
                    return 0;
                  })
                ];
                break;
              case "body.공정분류.raw.중분류":
                this.중분류 = [
                  '전체', ...response[key].sort((a, b) => {
                    if (a > b) return 1;
                    if (a < b) return -1;
                    return 0;
                  })
                ];
                break;
              case "body.공정분류.raw.소분류":
                this.소분류 = [
                  '전체', ...response[key].sort((a, b) => {
                    if (a > b) return 1;
                    if (a < b) return -1;
                    return 0;
                  })
                ];
                break;
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    // 팝업이 열릴 경우 / 검색버튼을 누를 경우 / 페이지를 변경 했을 경우 호출됨.
    async loadList () {

      this.loading(true)

      // 조회에 시간이 오래 걸릴 수 있으므로, 이전 목록을 비우고 안내 문구를 표시한다
      this.isLoading = true;
      this.list = [];

      try {
        const params = {
          boardIds: [813, 814],
          page: this.currentPage,
          perPage: this.perPage,
          sortBy: 'created_at',
          isParent: 'false',
        }

        // category1/2/3, team_name, factory_name 은 텍스트 매칭 (id 매칭 미지원) — loadOptions()의 TODO 참고
        if (this.nav.팀업체명 && this.nav.팀업체명 !== "전체") {
          params.teamName = this.nav.팀업체명;
        }
        if (this.nav.공장명 && this.nav.공장명 !== "전체") {
          params.factoryName = this.nav.공장명;
        }
        if (this.nav.대분류 && this.nav.대분류 !== "전체") {
          params.category1 = this.nav.대분류;
        }
        if (this.nav.중분류 && this.nav.중분류 !== "전체") {
          params.category2 = this.nav.중분류;
        }
        if (this.nav.소분류 && this.nav.소분류 !== "전체") {
          params.category3 = this.nav.소분류;
        }
        if (this.nav.키워드) {
          params.keyword = this.nav.키워드;
        }

        if (this.selectedFieldId && this.selectedFieldId > 0) {
          params.fieldId = this.selectedFieldId;
        }

        const response = await this.$store.dispatch('board/LOAD_RISK_ASSESSMENT', params);

        this.currentPage = response.pagination.current_page || 1;
        this.lastPage = response.pagination.last_page || 1;
        this.total = response.pagination.total || 0;
        this.perPage = response.pagination.per_page || 5;

        const list = response.data || [];
        for (const item of list) {
          item.id = `${item.post_id}_${item.item_index}`;
        }
        this.list = response.data || [];
      } catch (error) {
        this.customAlert("데이터 로드에 실패했습니다.")
      } finally {
        // 로딩 상태 비활성화
        this.isLoading = false;
        this.loading(false);
      }
    },

    loadFieldList (page) {
      if (page === 1) {
        this.fields = [];
        this.loading(true);
      }

      this.$store.dispatch("project/LOAD_FIELD_LIST", {
        projectId: this.projectId,
        page,
        perPage: 50,
      }).then((response) => {
        const data = response.data;
        this.fields.push(...data)
        if (response.last_page > page) {
          this.loadFieldList(page + 1);
        } else {
          this.loading(false);
        }
      });
    },


    // dotted path를 통해서 json 데이터를 찾는다
    // ex> findJsonDataWithDottedPath({a: {b: {c: 1}}}, 'a.b.c') => 1
    findJsonDataWithDottedPath(json, path) {
      try {
        const _keys = Object.keys(json);
        if (_keys.length === 0) {
          return "";
        }
        const paths = path.split(".");
        let result = json;
        for (const p of paths) {
          result = result[p];
        }
        return result;
      } catch (err) {
        return "";
      }
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    changeAllCheck (event) {
      const checked = event.target.checked

      // 전체 체크 시 maxItemCount 제한 적용
      if (checked) {
        if (this.maxItemCount > 0 && this.currentPageItems.length > this.maxItemCount) {
          // maxItemCount가 0이 아니고 현재 페이지 아이템이 maxItemCount보다 많을 경우
          const selectedItems = this.currentPageItems.slice(0, this.maxItemCount);

          // 이미 체크된 항목 유지하면서 최대 개수까지만 추가
          this.checked = [...this.checked];
          for (const item of selectedItems) {
            if (!this.checked.find(checkedItem => checkedItem.id === item.id) &&
                this.checked.length < this.maxItemCount) {
              this.checked.push(item);
            }
          }

          this.customAlert(`최대 ${this.maxItemCount}개까지만 선택할 수 있습니다.`);
        } else {
          // 제한이 없거나 현재 페이지 아이템이 maxItemCount보다 적을 경우
          for (const item of this.currentPageItems) {
            if (!this.checked.find(checkedItem => checkedItem.id === item.id)) {
              this.checked.push(item);
            }
          }
        }
      } else {
        // 전체 체크 해제
        this.checked = this.checked.filter(checkedItem => !this.currentPageItems.some(item => item.id === checkedItem.id)
        );
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClose () {
      this.showPopup = false;
    },

    onSelect() {
      const selectedItems = this.checked.map(item => ({
        id: item.id,
        대분류: item.info.공정분류['raw.대분류'],
        중분류: item.info.공정분류['raw.중분류'],
        소분류: item.info.공정분류['raw.소분류'],
        위험구분: item.item_data.분류,
        원인: item.item_data.원인,
        위험요인: item.item_data.위험요인,
        현재관리상태: item.item_data.현재조치관리상태 || item.item_data.현재관리상태 || "",
        빈도: item.item_data.발생빈도,
        강도: item.item_data.위험강도,
        감소대책: item.item_data.감소대책,
        projectId: item.project_id,
        boardId: item.board_id,
        postId: item.post_id,
      }));
      this.$emit('select', selectedItems);
      this.showPopup = false;
    },

    onChangePage (page) {
      // 팝업이 닫힌 상태에서는 목록을 조회하지 않는다
      if (!this.showPopup) {
        return;
      }
      // k-pagination 은 mount 시점에 current 가 0 에서 value 로 바뀌면서 change 를 한번 발생시킨다.
      // 이 경우와, loadList()/nav 변경으로 currentPage 가 이미 갱신된 경우의 중복 호출을 막는다.
      if (page === this.currentPage) {
        return;
      }
      this.currentPage = page;
      this.loadList();
    },

    // 테이블에서 행이 클릭되면, 체크박스를 토글한다
    onRowToggle (item) {
      const existingItem = this.checked.find(checkedItem => checkedItem.id === item.id);

      if (existingItem) {
        // 이미 체크된 항목 제거
        this.checked = this.checked.filter(checkedItem => checkedItem.id !== item.id);
      } else {
        // 새 항목 추가 시 maxItemCount 체크
        if (this.maxItemCount > 0 && this.checked.length >= this.maxItemCount) {
          this.customAlert(`최대 ${this.maxItemCount}개까지만 선택할 수 있습니다.`);
          return;
        }

        this.checked.push(item);
      }
    },

    onApplyKeyword() {
      this.nav.키워드 = this.키워드;
    },

    onClearKeyword() {
      this.키워드 = "";
      this.nav.키워드 = "";
    },
  }
}
</script>

<style scoped lang="scss">
.keyword-search {
  margin-bottom: 20px;

  .search-label {
    font-weight: 500;
    font-size: 0.95rem;
    margin-right: 10px;
    min-width: 55px;
  }

  .search-input-container {
    position: relative;
    flex-grow: 1;
    .search-input {
      width: 100%;
    }

    .clear-button {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      margin: 0;
      min-width: 24px;
      min-height: 24px;
      border-radius: 50%;

      ::v-deep .vs-button-content {
        padding: 0;
      }
    }
  }

  .search-button {
    padding: 0.45rem 1.2rem;
    min-width: 80px;
  }
}

.search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  gap: 10px;

  & > div {
    display: grid;
    align-items: center;
    grid-template-columns: 114px 1fr;

    & > span {
      width: auto;
      margin-right: 10px;
    }
  }
}
table {
  width: 100%;
  min-width: 1540px;
  border-collapse: collapse;
  th, td {
    border: 1px solid #cdcdcd;
    padding: 0.75rem 0.5rem;
    text-align: center;
  }
  th {
    background-color: #F9F9F9;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;

    .header-select {
      min-width: 130px;
      max-width: 150px;
      margin: 0 auto;

      ::v-deep .vs-select {
        width: 100%;

        .vs-select--input {
          padding: 4px 8px;
          font-size: 0.85rem;
        }
      }
    }
  }
  .message-row {
    padding: 2.5rem 0.5rem;
    color: #6c6c6c;
    font-size: 0.95rem;
  }

  .loading-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(var(--vs-primary), 0.25);
    border-top-color: rgba(var(--vs-primary), 1);
    border-radius: 50%;
    animation: popup-risk-assessment-db-spin 0.8s linear infinite;
  }

  @keyframes popup-risk-assessment-db-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .table-row {
    cursor: pointer;
    background-color: white;
    &:hover {
      background-color: #efefef;
      &.active {
        /*--vs-primary 값의 투명도를 10% 적용*/
        background-color: rgba(var(--vs-primary), 0.15);
      }
    }
    &.active {
      background-color: rgba(var(--vs-primary), 0.1);
    }

    /* 체크박스가 클릭되지 않도록 disabled 처리했지만, 흐릿하게 표시되지 않도록 가시성 변경*/
    ::v-deep .vs-checkbox--input:disabled+.vs-checkbox {
      opacity: 1;
    }
  }
}
</style>

<style>
.popup-risk-assessment-db > .vs-popup {
  width: 1600px !important;
}
</style>
